// src/pages/Editor/components/VersionHistory/VersionSelectionModal.tsx
import { Button, Flex, ScrollArea, Tabs, Text } from '@mantine/core';
import { useMemo } from 'react';
import useRetrieveAutomationVersions from '@/hooks/api/automationVersions/useRetrieveAutomationVersions.ts';
import { flattenInfiniteQueryData } from '@/utils/misc.ts';
import CustomSpinner from '@/components/Spinner.tsx';
import PublishedVersionsTimeline from '@/pages/Editor/components/VersionHistory/VersionHistoryModal/PublishedVersionsTimeline.tsx';
import { Automation, AutomationVersionSimple } from '@/types/automations.ts';

type props = {
  automation: Automation;
  latestVersion?: AutomationVersionSimple;
};

const PublishedVersionsTab = ({ automation, latestVersion }: props) => {
  const {
    data: automationVersions,
    isPending,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useRetrieveAutomationVersions(true);

  const allVersions = useMemo(
    () => flattenInfiniteQueryData(automationVersions),
    [automationVersions],
  );

  return (
    <Tabs.Panel value="published">
      <ScrollArea h={300} px="md" py="xs">
        {isPending ? (
          <CustomSpinner />
        ) : allVersions.length > 0 ? (
          <PublishedVersionsTimeline
            versions={allVersions}
            publishedVersion={automation?.published_version || undefined}
            latestVersion={latestVersion}
          />
        ) : (
          <Flex justify="center" align="center" p="xl">
            <Text>No published versions available</Text>
          </Flex>
        )}
      </ScrollArea>

      {hasNextPage && (
        <Flex justify="center" mt="md">
          <Button
            variant="outline"
            size="xs"
            loading={isFetchingNextPage}
            onClick={() => fetchNextPage()}
          >
            Load More
          </Button>
        </Flex>
      )}
    </Tabs.Panel>
  );
};

export default PublishedVersionsTab;
